export default class AdwordsGoogleDisplay {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  // BUMPER
  async getGoogleDisplay(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId,
    type = ""
  ) {
    try {
      // customerId = "6777079217";
      // businessUnitId = "3";
      // type = "ALL";
      const googleDisplay = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/DISPLAY/${customerId}/businesses/${businessUnitId}/${type}?fromDate=${fromDate}&toDate=${toDate}`
      );

      return {
        ...googleDisplay.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  async getGoogleDisplayBudget(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId
  ) {
    try {
      const result = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/adwords/budget/${subscriberId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
      );
      customerId;
      return result.data[0].budget;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  async getGoogleDisplayBudgets(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId
  ) {
    try {
      const result = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/adwords/budgets/${subscriberId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
      );
      customerId;
      return result.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
}
